import importerStore from '@shared/importer/importer-store';
import { PropertyService } from '@modules/property/property-service';
import propertyImporterFields from '@modules/property/property-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  PropertyService.import,
  propertyImporterFields,
  i18n('entities.property.importer.fileName'),
  i18n('entities.property.importer.hint'),
);
